import type { FC, ReactNode } from 'react';
import { cn } from '../../lib/utils/cn';

type Props = {
  label?: string;
  htmlFor?: string;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  className?: string;
  children: ReactNode;
};

const FormField: FC<Props> = ({
  label,
  htmlFor,
  hint,
  error,
  required,
  className,
  children
}) => {
  return (
    <div className={cn('space-y-2', className)}>
      {label ? (
        <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700">
          {label}
          {required ? <span className="text-red-600"> *</span> : null}
        </label>
      ) : null}

      {children}

      {error ? <p className="text-sm text-red-600">{error}</p> : null}
      {!error && hint ? <p className="text-sm text-gray-500">{hint}</p> : null}
    </div>
  );
};

export default FormField;
